<template>
    <svg width="20" height="21" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.066 0H2.403A2.389 2.389 0 0 0 0 2.374v10.212a2.389 2.389 0 0 0 2.403 2.374h8.987l4.594 5.905V14.96h1.082a2.39 2.39 0 0 0 2.404-2.374V2.374A2.39 2.39 0 0 0 17.066 0z" fill="#1D1D1D" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {
    name: 'IconOpinions',
};
</script>
